export default __webpack_public_path__ + "static/media/scooter.837e0953.svg";